import { defineComponent as _defineComponent } from 'vue'
import { watch, ref, computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { config } from '@/store';
import mangaApi from '@/api/manga';
import {
	get_collect,
	add_collect,
	is_collect,
	remove_collect,
} from '@/api/collect';
import { ElMessageBox } from 'element-plus';
import i18n from '@/i18n';
import tagApi, { tagItemType } from '@/api/tag';


export default /*#__PURE__*/_defineComponent({
  __name: 'right-sidebar',
  props: ['mangaInfo', 'menuPoster'],
  emits: ['reload'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const { t } = i18n.global;

const route = useRoute();

const drawer = ref(false);
const isCollect = ref(false);
const editTagsDialog = ref(false);

let tagList = ref<tagItemType[]>([]);
let checkedTagList = ref<tagItemType[]>([]);

let noCheckedTagList = computed<tagItemType[]>(() => {
	let arr: tagItemType[] = [];
	const checkedTagListNames = checkedTagList.value.map((i) => i.tagId);

	tagList.value.forEach(element => {

		if (!checkedTagListNames.includes(element.tagId)) arr.push(element);
	});

	return arr;
});

const props = __props;
const emit = __emit;

const mangaName = computed(() => {
	return props.mangaInfo.mangaName;
});

const mangaId = computed(() => {
	return props.mangaInfo.mangaId;
});

const blob = computed(() => {
	return props.menuPoster;
});

watch(
	() => config.rightSidebar,
	(val) => {
		drawer.value = val;
	}
);

watch(
	() => props.mangaInfo.mangaId,
	async (val) => {
		const res = await is_collect('manga', val);
		isCollect.value = res.data.isCollect;
	}
);

onMounted(async () => {
	tagList.value = await tagApi.get_nopage();
});

/**
 * @description: 更新漫画收藏状态
 * @return {*}
 */
async function update_collect_state() {
	const res = await is_collect('manga', mangaId.value);
	isCollect.value = res.data.isCollect;
}

/**
 * @description: 更新标签状态
 * @return {*}
 */
async function update_tags_state() {
	checkedTagList.value = await tagApi.get_manga_tag(mangaId.value);
}

/**
 * @description: 关闭右侧菜单
 * @return {*}
 */
function close_sidebar() {
	config.rightSidebar = false;
}

/**
 * @description: 更新标签状态
 * @return {*}
 */
function update_tags() {
	ElMessageBox.alert('我正在编辑标签');
}

/**
 * @description: 增加漫画标签
 * @param {*} tagItem
 * @return {*}
 */
async function add_manga_tag(tagItem: tagItemType) {
	await tagApi.add_manga_tag(mangaId.value, tagItem.tagId);
	update_tags_state();
}

/**
 * @description: 移除漫画标签
 * @param {*} mangaTagId
 * @return {*}
 */
async function remove_tag(mangaTagId: number) {
	await tagApi.remove_manga_tag(mangaTagId);
	update_tags_state();
}

/**
 * @description: 右侧菜单项选择事件
 * @param {*} key
 * @return {*}
 */
async function menu_select(key: string) {
	const mangaInfo = props.mangaInfo;
	switch (key) {
		case 'remove':
			ElMessageBox.confirm(t('mangaManage.confirm.text1'), { type: 'warning' })
				.then(async () => {
					await mangaApi.delete_manga(mangaId.value);
					emit('reload');
				})
				.catch();

			break;
		case 'delete':
			ElMessageBox.confirm(t('mangaManage.confirm.text2'), {
				type: 'warning',
			}).then(async () => {
				await mangaApi.delete_manga(mangaId.value, true);
				emit('reload');
			});

			break;
		case 'collect':
			if (isCollect.value) {
				await remove_collect('manga', mangaId.value);
			} else {
				await add_collect(
					Object.assign(mangaInfo, {
						collectType: 'manga',
						chapterId: -1,
						chapterName: null,
					})
				);
			}
			update_collect_state();
			break;
		case 'tags':
			editTagsDialog.value = true;
			update_tags_state();
			break;

	}
	close_sidebar();
}

const __returned__ = { t, route, drawer, isCollect, editTagsDialog, get tagList() { return tagList }, set tagList(v) { tagList = v }, get checkedTagList() { return checkedTagList }, set checkedTagList(v) { checkedTagList = v }, get noCheckedTagList() { return noCheckedTagList }, set noCheckedTagList(v) { noCheckedTagList = v }, props, emit, mangaName, mangaId, blob, update_collect_state, update_tags_state, close_sidebar, update_tags, add_manga_tag, remove_tag, menu_select, get config() { return config } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})